import { render, staticRenderFns } from "./EntityEdit.vue?vue&type=template&id=50ef99bd"
import script from "./EntityEdit.vue?vue&type=script&lang=js"
export * from "./EntityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports